export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 110,
    fixed: 'left',
    slots: {
      default: 'opt',
    },
  },
  {
    headerAlign: 'center',
    field: 'transferStationName',
    align: 'left',
    width: 250,
    title: '中转站名称',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'transferStationType',
    align: 'center',
    width: 120,
    title: '中转站类型',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'isVirtualName',
    align: 'center',
    width: 80,
    title: '是否虚拟',
    slots: { default: 'virtual' },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'tdpStationNo',
    align: 'left',
    width: 140,
    title: '三方站点编号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'orgName',
    align: 'left',
    width: 220,
    title: '所属机构',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'trusteeshipOrgName',
    align: 'left',
    width: 220,
    title: '托管机构',
    sortable: true,
    sortType: 'string',
    showOverflow: 'ellipsis',
    showHeaderOverflow: 'title',
  },
  {
    headerAlign: 'center',
    field: 'contactName',
    align: 'left',
    width: 120,
    title: '联系人姓名',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'contactMobile',
    align: 'left',
    width: 140,
    title: '联系人手机号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'provinceName',
    align: 'left',
    width: 100,
    title: '省份',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'cityName',
    align: 'left',
    width: 100,
    title: '城市',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'districtName',
    align: 'left',
    width: 100,
    title: '区县',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'areaName',
    align: 'left',
    width: 100,
    title: '区域',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    headerAlign: 'center',
    field: 'transferStationAddress',
    align: 'left',
    width: 280,
    title: '详细地址',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'transferStationRemarks',
    align: 'left',
    width: 300,
    title: '备注',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'transferStationStatusName',
    align: 'center',
    width: 80,
    title: '状态',
    slots: { default: 'status' },
  },
  {
    headerAlign: 'center',
    field: 'createByName',
    title: '创建人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'createTime',
    title: '创建时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'modifyByName',
    title: '修改人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'modifyTime',
    title: '修改时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
]
